import { render, staticRenderFns } from "./travelEdit.vue?vue&type=template&id=55979007&scoped=true&lang=html&"
import script from "./travelEdit.vue?vue&type=script&lang=js&"
export * from "./travelEdit.vue?vue&type=script&lang=js&"
import style0 from "./travelEdit.vue?vue&type=style&index=0&id=55979007&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55979007",
  null
  
)

export default component.exports